import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { getYoutubeId, getYoutubePlaylistId, isVideoFile } from 'utils/assets';

import s from 'components/trailerModal/trailerModal.sss';

export default class TrailerModal extends Component {
	constructor(props) {
		super(props);

		this.close = this.close.bind(this);
		// this.onClick = this.onClick.bind(this);
		// this.onLinkClick = this.onLinkClick.bind(this);
	}

	close() {
		this.base.close();
	}

	onClick(e) {
		if (e.target === e.currentTarget) {
			// Not clicking on a child element ~= clicking on the backdrop
			e.currentTarget.close();
		}
	}

	onLinkClick(e) {
		Store.emit(actions.TRAILER_MORE_INFO_CLICK, { title: e.currentTarget.textContent });
	}

	renderVideo() {
		const url = this.props.trailer;

		// YouTube videos and playlists
		const youtubePlaylist = getYoutubePlaylistId(url);
		const youtubeId = getYoutubeId(url);
		if (youtubeId || youtubePlaylist) {
			let src = new URL(`https://www.youtube.com/embed/${youtubeId || ''}`);
			src.searchParams.set('autoplay', '1');
			src.searchParams.set('controls', '1');
			if (youtubePlaylist) src.searchParams.set('list', youtubePlaylist);
			return (
				<iframe
					class={s.video}
					src={src.href}
					allow="autoplay; encrypted-media"
					allowfullscreen
				/>
			);
		}

		// Direct video file
		if (isVideoFile(url)) {
			return (
				<video
					class={s.video}
					src={url}
					autoplay
					controls
					playsinline
					poster={this.props?.data?.poster}
				/>
			);
		}

		return null;
	}

	renderLink() {
		const link = this.props?.data?.link;
		if (!link?.destination || !link?.label) return null;
		return (
			<a href={link.destination} class={s.cta} target="_blank" rel="noopener noreferrer" onClick={this.onLinkClick}>{link.label}</a>
		);
	}

	render() {
		return (
			<dialog class={s.wrapper} onClick={this.onClick}>
				<button type="button" class={s.close} onClick={this.close}>
					<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
						<path d="M1.91249 1.4181C1.71749 1.41904 1.54311 1.5381 1.47094 1.71904C1.39781 1.89998 1.44281 2.10717 1.5825 2.2431L11.3251 11.9857L1.5825 21.7282C1.47656 21.8135 1.41188 21.9401 1.40438 22.076C1.39781 22.212 1.44844 22.3442 1.545 22.4407C1.64063 22.5373 1.77375 22.5879 1.90968 22.5804C2.04562 22.5738 2.17219 22.5091 2.25749 22.4032L12 12.6607L21.7426 22.4032C21.8279 22.5092 21.9545 22.5738 22.0904 22.5813C22.2264 22.5879 22.3595 22.5373 22.4551 22.4407C22.5517 22.3451 22.6023 22.212 22.5957 22.076C22.5882 21.9401 22.5235 21.8135 22.4176 21.7282L12.675 11.9857L22.4176 2.2431C22.5601 2.10529 22.6032 1.8953 22.5273 1.71249C22.4504 1.53061 22.2704 1.41342 22.0726 1.4181C21.947 1.42279 21.8289 1.47717 21.7426 1.5681L12 11.3107L2.25748 1.5681C2.16748 1.47342 2.0428 1.41904 1.91249 1.4181Z" />
					</svg>
				</button>
				{this.renderVideo()}
				{this.renderLink()}
			</dialog>
		);
	}
}